import { createContext } from 'react';

export const InvoiceSettingsContext = createContext<any>({
  setInvoiceSettingsReferenceElement: null,
  invoiceSettingsReferenceElement: null,
});
